var _g, _g2, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignInovationThinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 1122",
    style: {
      enableBackground: "new 0 0 1800 1122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 1122
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M128.033,302.129c-13.534,0-24.545-11.011-24.545-24.545c0-13.534,11.011-24.545,24.545-24.545 c13.534,0,24.545,11.011,24.545,24.545C152.578,291.119,141.568,302.129,128.033,302.129z M128.033,259.445 c-10.002,0-18.139,8.137-18.139,18.139c0,10.002,8.137,18.139,18.139,18.139c10.002,0,18.139-8.137,18.139-18.139 C146.173,267.583,138.036,259.445,128.033,259.445z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M1565.187,438.325c-35.247,0-63.923-28.676-63.923-63.923c0-35.247,28.676-63.923,63.923-63.923 s63.923,28.676,63.923,63.923C1629.11,409.649,1600.434,438.325,1565.187,438.325z M1565.187,316.884 c-31.715,0-57.518,25.802-57.518,57.518c0,31.715,25.803,57.518,57.518,57.518s57.518-25.802,57.518-57.518 C1622.705,342.686,1596.902,316.884,1565.187,316.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M504.272,1035.708c-11.371,0-22.457-3.453-31.99-10.082c-12.333-8.577-20.588-21.443-23.244-36.228 c-2.656-14.785,0.604-29.72,9.181-42.053c8.577-12.333,21.443-20.588,36.228-23.244c14.785-2.655,29.72,0.604,42.053,9.181 c12.333,8.577,20.588,21.443,23.244,36.228c2.656,14.785-0.604,29.72-9.181,42.053c-8.577,12.333-21.443,20.588-36.228,23.244 C510.979,1035.41,507.613,1035.708,504.272,1035.708z M504.497,929.607c-2.961,0-5.942,0.264-8.917,0.799 c-13.101,2.354-24.502,9.668-32.102,20.596c-7.6,10.928-10.489,24.162-8.135,37.263c2.354,13.101,9.668,24.502,20.596,32.102 c10.928,7.6,24.162,10.489,37.263,8.135c13.101-2.354,24.502-9.668,32.102-20.596c7.6-10.928,10.489-24.162,8.135-37.263l0,0 c-2.354-13.101-9.668-24.502-20.596-32.102C524.397,932.667,514.573,929.607,504.497,929.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M86.249,448.116c-17.544,0-31.816-14.273-31.816-31.816c0-17.544,14.273-31.816,31.816-31.816 c17.544,0,31.816,14.273,31.816,31.816C118.065,433.843,103.793,448.116,86.249,448.116z M86.249,390.888 c-14.012,0-25.411,11.399-25.411,25.411c0,14.012,11.399,25.411,25.411,25.411c14.012,0,25.411-11.399,25.411-25.411 C111.66,402.288,100.261,390.888,86.249,390.888z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M481.889,502.7c-8.912,0-16.163-7.251-16.163-16.163c0-8.912,7.251-16.163,16.163-16.163 c8.912,0,16.163,7.251,16.163,16.163C498.052,495.449,490.801,502.7,481.889,502.7z M481.889,476.78 c-5.38,0-9.757,4.377-9.757,9.758c0,5.38,4.377,9.757,9.757,9.757c5.38,0,9.758-4.377,9.758-9.757 C491.646,481.157,487.269,476.78,481.889,476.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M1604.129,150.802c-12.936,0-23.46-10.524-23.46-23.46c0-12.936,10.524-23.46,23.46-23.46 c12.936,0,23.46,10.524,23.46,23.46C1627.589,140.278,1617.065,150.802,1604.129,150.802z M1604.129,110.288 c-9.404,0-17.054,7.651-17.054,17.054c0,9.404,7.651,17.054,17.054,17.054c9.404,0,17.054-7.65,17.054-17.054 C1621.183,117.939,1613.533,110.288,1604.129,110.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M503.583,191.487H262.655v-82.105h240.928V191.487z M269.061,185.082h228.117v-69.294H269.061 V185.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M1123.782,179.396h-122.986V86.213h122.986V179.396z M1007.202,172.99h110.175V92.618h-110.175 V172.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M1750,832.861h-125.775V591.933H1750V832.861z M1630.63,826.456h112.964V598.339H1630.63V826.456z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M977.31,1069.096H828.889v-82.105H977.31V1069.096z M835.294,1062.691h135.61v-69.294h-135.61 V1062.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E6"
    },
    d: "M1352.287,864.294c-20.107,0-36.465-16.358-36.465-36.465c0-20.107,16.358-36.465,36.465-36.465 s36.465,16.358,36.465,36.465C1388.752,847.936,1372.394,864.294,1352.287,864.294z M1352.287,798.482 c-16.183,0-29.348,13.165-29.348,29.348c0,16.182,13.165,29.348,29.348,29.348c16.182,0,29.348-13.165,29.348-29.348 C1381.635,811.647,1368.469,798.482,1352.287,798.482z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M1260.781,1042.815c-37.395,0-72.634-8.032-99.225-22.616 c-13.203-7.241-23.618-15.737-30.955-25.25c-7.865-10.199-11.853-21.114-11.853-32.442c0-11.328,3.988-22.243,11.853-32.442 c7.337-9.514,17.752-18.009,30.955-25.25c26.592-14.584,61.831-22.616,99.225-22.616c37.395,0,72.634,8.032,99.226,22.616 c13.203,7.241,23.618,15.737,30.955,25.25c7.865,10.199,11.853,21.114,11.853,32.442c0,11.328-3.988,22.243-11.853,32.442 c-7.337,9.514-17.752,18.009-30.955,25.25C1333.415,1034.783,1298.176,1042.815,1260.781,1042.815z M1260.781,892.874 c-35.631,0-69.047,7.565-94.092,21.301c-11.905,6.529-21.202,14.069-27.635,22.41c-6.391,8.287-9.631,17.008-9.631,25.922 c0,8.914,3.24,17.635,9.631,25.922c6.433,8.341,15.73,15.881,27.635,22.41c25.045,13.736,58.461,21.301,94.092,21.301 c35.631,0,69.047-7.565,94.092-21.301c11.905-6.529,21.202-14.069,27.635-22.41c6.391-8.287,9.631-17.008,9.631-25.922 c0-8.914-3.24-17.635-9.631-25.922c-6.433-8.341-15.73-15.881-27.635-22.41C1329.828,900.439,1296.412,892.874,1260.781,892.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E6"
    },
    d: "M908.273,941.344c-50.171,0-98.844-9.827-144.665-29.208 c-44.257-18.719-84.003-45.516-118.133-79.647c-34.131-34.131-60.928-73.877-79.647-118.133 c-19.381-45.822-29.208-94.494-29.208-144.666c0-50.171,9.827-98.844,29.208-144.665c18.719-44.257,45.516-84.003,79.646-118.133 l5.032,5.033c-33.479,33.479-59.764,72.465-78.124,115.873c-19.008,44.94-28.646,92.679-28.646,141.893 c0,49.214,9.638,96.953,28.646,141.893c18.36,43.408,44.645,82.394,78.125,115.873c33.48,33.48,72.465,59.765,115.873,78.125 c44.939,19.008,92.679,28.646,141.893,28.646c49.214,0,96.953-9.638,141.893-28.646c43.408-18.36,82.394-44.645,115.873-78.125 c33.479-33.48,59.765-72.465,78.125-115.873c19.008-44.94,28.646-92.679,28.646-141.893s-9.638-96.953-28.646-141.893 c-18.36-43.408-44.645-82.394-78.125-115.873c-33.48-33.48-72.465-59.765-115.873-78.125 c-44.94-19.008-92.679-28.646-141.893-28.646c-48.878,0-96.324,9.516-141.021,28.283l-2.755-6.562 c45.574-19.135,93.947-28.838,143.776-28.838c50.171,0,98.844,9.827,144.666,29.208c44.257,18.719,84.003,45.516,118.133,79.647 c34.131,34.131,60.928,73.877,79.647,118.133c19.381,45.822,29.208,94.494,29.208,144.665c0,50.171-9.827,98.844-29.208,144.666 c-18.719,44.257-45.516,84.002-79.647,118.133c-34.131,34.131-73.877,60.928-118.133,79.647 C1007.117,931.517,958.444,941.344,908.273,941.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1219.942,
    y: 125.563,
    transform: "matrix(0.5327 -0.8463 0.8463 0.5327 477.3365 1119.1104)",
    style: {
      fill: "#59595C"
    },
    width: 64.088,
    height: 3.558
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1156.447,
    y: 248.065,
    transform: "matrix(0.7219 -0.692 0.692 0.7219 152.7298 879.7474)",
    style: {
      fill: "#59595C"
    },
    width: 29.03,
    height: 3.559
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M1200.329,304.768l-3.201-1.554l3.109-6.402l3.201,1.554L1200.329,304.768z M1204.992,295.164 l-3.201-1.554l3.109-6.402l3.201,1.554L1204.992,295.164z M1209.655,285.561l-3.201-1.554l3.109-6.402l3.201,1.554 L1209.655,285.561z M1214.318,275.957l-3.201-1.554l3.109-6.402l3.201,1.554L1214.318,275.957z M1218.981,266.354l-3.201-1.554 l3.109-6.402l3.201,1.554L1218.981,266.354z M1223.644,256.75l-3.201-1.555l0.413-0.85l3.201,1.555L1223.644,256.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1290.177,
    y: 239.218,
    transform: "matrix(0.7125 -0.7016 0.7016 0.7125 180.2725 984.7941)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 66.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1277.331,
    y: 185.247,
    transform: "matrix(1 -0.0033 0.0033 1 -0.618 4.4162)",
    style: {
      fill: "#59595C"
    },
    width: 85.974,
    height: 3.559
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1133.9,
    y: 163.278,
    transform: "matrix(0.0796 -0.9968 0.9968 0.0796 849.8636 1312.4703)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 65.455
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -788.3253 954.3619)",
    style: {
      fill: "#DBDBDA"
    },
    cx: 208.781,
    cy: 975.227,
    rx: 70.512,
    ry: 70.512
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 940.486,
    y: 70.253,
    style: {
      fill: "#DBDBDA"
    },
    width: 80.525,
    height: 59.94
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340.728,
    y: 603.064,
    style: {
      fill: "#DBDBDA"
    },
    width: 167.035,
    height: 210.368
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.122,540.133h-1.135c0,0-93.756-20.398-145.507,0v134.349c51.751-20.398,145.507,0,145.507,0 h1.135c0,0,93.756-20.398,145.507,0V540.133C430.878,519.736,337.122,540.133,337.122,540.133z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M484.409,677.096l-2.432-0.958c-14.573-5.744-42.244-11.714-91.312-7.535 c-29.459,2.508-52.931,7.568-53.164,7.619l-0.187,0.041h-1.518l-0.187-0.041c-0.234-0.051-23.706-5.11-53.164-7.619 c-49.069-4.178-76.74,1.792-91.312,7.535l-2.432,0.958V538.922l1.127-0.444c21.72-8.561,52.998-11.174,92.964-7.767 c28.27,2.41,51.078,7.153,53.384,7.643h0.759c2.306-0.489,25.114-5.233,53.384-7.643c39.967-3.407,71.244-0.794,92.964,7.767 l1.127,0.444V677.096z M336.174,672.702h0.76c2.306-0.489,25.114-5.233,53.384-7.643c38.498-3.282,68.935-0.978,90.532,6.848 V541.354c-14.854-5.604-42.353-11.174-90.186-7.101c-29.459,2.508-52.931,7.568-53.164,7.619l-0.187,0.041h-1.518l-0.187-0.041 c-0.234-0.051-23.706-5.11-53.164-7.619c-47.832-4.073-75.332,1.497-90.186,7.101v130.553 c21.597-7.825,52.034-10.129,90.532-6.848C311.06,667.47,333.868,672.213,336.174,672.702z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M938.021,1029.764c-6.369-8.351-14.615-15.053-25.033-17.522 c-10.001-2.37-20.601-0.428-29.248,5.078c-4.028,2.565-7.948,5.278-12.057,7.717c-1.901,1.128-3.839,2.194-5.81,3.194 c-0.959,0.487-1.934,0.944-2.914,1.387c-1.766,0.798,1.959-0.798,0.178-0.066c-0.644,0.265-1.297,0.508-1.951,0.747 c-1.915,0.701-3.883,1.249-5.878,1.668c-0.49,0.103-0.983,0.185-1.476,0.267c-1.852,0.307,2.255-0.26,0.392-0.065 c-1.151,0.12-2.309,0.149-3.466,0.138c-0.763-0.008-4.264-0.389-1.12,0.036c-1.013-0.137-2.012-0.357-3.003-0.604 c-1.026-0.256-2.029-0.598-3.019-0.965c-1.838-0.681,1.917,0.867,0.103,0.042c-0.692-0.315-1.363-0.672-2.03-1.033 c-1.056-0.572-2.067-1.226-3.061-1.899c-0.524-0.355-1.031-0.734-1.538-1.113c1.857,1.388,0.057-0.005-0.258-0.27 c-1.828-1.541-3.61-3.154-5.305-4.841c-2.733-2.721-5.235-5.674-8.219-8.134c-3.956-3.261-8.384-5.798-13.485-6.751 c-5.899-1.103-11.835-0.968-17.672,0.44c-9.65,2.328-17.814,8.395-25.734,14.063c-1.948,1.395-3.992,2.669-6.058,3.882 c-0.942,0.553-1.903,1.072-2.872,1.574c-0.461,0.239-0.929,0.463-1.398,0.688c-0.573,0.274-2.87,1.205-0.159,0.1 c-1.728,0.704-3.519,1.239-5.342,1.627c-0.439,0.094-0.882,0.165-1.325,0.236c2.929-0.471,1.274-0.172,0.594-0.11 c-1.042,0.094-2.091,0.097-3.136,0.065c-0.611-0.019-1.22-0.074-1.828-0.135c-1.566-0.154,2.445,0.406,0.028-0.027 c-1.492-0.268-2.957-0.672-4.403-1.121c-0.693-0.215-1.376-0.46-2.059-0.706c-0.552-0.2-3.566-1.466-1.105-0.406 c-1.773-0.764-3.505-1.622-5.222-2.505c-4.312-2.219-9.626-1.156-12.172,3.192c-2.35,4.012-1.117,9.955,3.192,12.172 c4.818,2.479,9.851,4.772,15.117,6.113c5.107,1.301,10.107,1.431,15.282,0.689c9.29-1.332,17.507-6.858,24.964-12.202 c3.78-2.709,7.616-5.344,11.736-7.514c0.983-0.517,1.989-0.987,3.004-1.436c-2.6,1.149,0.829-0.254,1.495-0.474 c1.054-0.347,2.13-0.619,3.212-0.86c0.545-0.121,1.096-0.214,1.646-0.305c-2.814,0.469-0.188,0.058,0.443,0.014 c1.159-0.08,2.323-0.054,3.482,0.007c0.588,0.031,1.173,0.099,1.761,0.14c2.019,0.141-2.127-0.357-0.202-0.045 c0.989,0.16,1.957,0.424,2.91,0.727c0.597,0.189,2.223,0.894-0.376-0.221c0.555,0.238,1.09,0.522,1.62,0.811 c0.778,0.425,1.514,0.925,2.233,1.441c1.388,0.996-1.732-1.39-0.413-0.302c0.342,0.282,0.673,0.579,1.003,0.875 c1.475,1.32,2.833,2.771,4.196,4.205c7.188,7.563,15.344,14.658,25.637,17.429c10.301,2.773,20.547,0.283,30.034-3.912 c4.212-1.862,8.203-4.206,12.105-6.641c3.965-2.475,7.734-5.388,11.909-7.5c0.462-0.234,0.936-0.444,1.409-0.655 c-2.459,1.092-0.786,0.352-0.229,0.149c0.94-0.343,1.904-0.614,2.872-0.858c0.755-0.19,4.207-0.692,1.012-0.289 c1.122-0.142,2.254-0.186,3.384-0.191c0.965-0.004,1.928,0.066,2.888,0.161c1.83,0.181-2.269-0.351-0.454-0.047 c0.477,0.08,0.95,0.184,1.423,0.288c0.951,0.209,1.886,0.489,2.811,0.79c0.467,0.152,0.926,0.326,1.385,0.501 c1.456,0.553-2.06-0.952,0.146,0.092c1.063,0.504,2.085,1.09,3.087,1.704c0.583,0.358,1.148,0.746,1.708,1.138 c0.282,0.2,0.561,0.405,0.837,0.613c-1.108-0.865-1.297-1.004-0.568-0.417c1.108,0.902,2.142,1.891,3.141,2.912 c0.512,0.524,0.999,1.073,1.482,1.625c0.362,0.414,1.983,2.5,0.37,0.386c1.475,1.934,2.872,3.416,5.317,4.088 c2.296,0.632,4.8,0.307,6.855-0.897C938.628,1039.711,940.969,1033.63,938.021,1029.764L938.021,1029.764z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808083"
    },
    d: "M1491.523,438.28c0,9.827-7.966,17.793-17.793,17.793h-113.875 c-9.827,0-17.793-7.966-17.793-17.793v-65.69c0-9.827,7.966-17.793,17.793-17.793h113.875c9.827,0,17.793,7.966,17.793,17.793 V438.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1473.73,458.564h-113.875c-11.185,0-20.284-9.099-20.284-20.284v-65.69 c0-11.185,9.099-20.284,20.284-20.284h113.875c11.184,0,20.284,9.099,20.284,20.284v65.69 C1494.014,449.464,1484.915,458.564,1473.73,458.564z M1359.855,357.288c-8.437,0-15.302,6.865-15.302,15.302v65.69 c0,8.438,6.865,15.302,15.302,15.302h113.875c8.437,0,15.302-6.864,15.302-15.302v-65.69c0-8.438-6.865-15.302-15.302-15.302 H1359.855z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1165.293,559.02l84.898-3.425c-2.015-50.814-15.114-98.778-36.947-141.54l-75.721,38.584 C1153.934,484.779,1163.779,520.828,1165.293,559.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M908.411,826.474c-70.444,0-134.267-28.335-180.703-74.226l-59.721,60.436 c61.783,61.057,146.699,98.757,240.424,98.757c5.877,0,11.719-0.149,17.523-0.442l-4.353-84.857 C917.219,826.362,912.828,826.474,908.411,826.474z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1142.015,676.873l77.205,35.524c5.158-11.192,9.73-22.709,13.675-34.513l-80.549-27.113 C1149.37,659.7,1145.916,668.41,1142.015,676.873z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1045.843,786.691l45.421,71.819c41.637-26.388,77.182-61.52,104.054-102.817l-71.268-46.279 C1103.852,740.453,1077.137,766.858,1045.843,786.691z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1162.686,607.531c-1.675,11.261-4.08,22.284-7.166,33.018l81.613,23.71 c4.122-14.309,7.336-29.003,9.573-44.016L1162.686,607.531z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1164.039,596.918l84.476,9.176c0.664-6.224,1.166-12.497,1.492-18.816l-84.852-4.445 C1164.91,587.564,1164.535,592.259,1164.039,596.918z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A6A9"
    },
    d: "M1125.718,431.953l71.819-45.421c-57.648-90.963-157.036-152.858-271.232-158.743l-4.445,84.852 C1007.69,317.065,1082.39,363.585,1125.718,431.953z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M660.423,637.415l-81.959,22.484c4.021,14.692,8.994,28.99,14.855,42.822l78.269-33.121 C667.183,659.204,663.445,648.457,660.423,637.415z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M932.341,825.371l7.909,84.603c35.706-3.296,69.823-12.075,101.498-25.496l-33.121-78.269 C984.82,816.295,959.178,822.893,932.341,825.371z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M651.322,569.384c0-77.142,33.979-146.344,87.783-193.467l-55.518-64.324 c-71.839,62.705-117.231,154.945-117.231,257.791c0,26.332,2.979,51.968,8.612,76.592l82.828-19.026 C653.561,608.443,651.322,589.175,651.322,569.384z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M698.68,718.105l-69.315,49.152c8.768,12.342,18.333,24.079,28.623,35.132l62.206-57.879 C712.459,736.203,705.27,727.382,698.68,718.105z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1018.469,801.787l36.374,76.808c2.99-1.418,5.958-2.875,8.899-4.377l-38.584-75.721 C1022.946,799.626,1020.716,800.721,1018.469,801.787z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M676.009,679.442l-76.808,36.374c6.507,13.715,13.898,26.928,22.103,39.567l71.318-46.202 C686.455,699.681,680.899,689.75,676.009,679.442z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M898.047,312.502l-3.425-84.899c-21.802,0.864-43.079,3.767-63.646,8.527l19.486,82.722 C865.842,315.31,881.749,313.148,898.047,312.502z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M827.909,325.155l-27.057-80.567c-33.364,11.043-64.45,27.082-92.375,47.232l49.33,69.187 C778.975,345.681,802.571,333.502,827.909,325.155z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M1054.257,505.575c0-80.625-65.359-145.984-145.984-145.984S762.289,424.95,762.289,505.575 c0,64.345,41.631,118.964,99.427,138.399v42.443h93.114v-42.443C1012.626,624.539,1054.257,569.92,1054.257,505.575z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "900.646,700.674 861.716,722.01 861.716,736.721 927.487,700.674  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "954.83,743.906 954.83,729.195 861.716,780.229 861.716,793.788 864.779,793.788  864.556,793.383  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "954.83,758.304 890.087,793.788 916.928,793.788 954.83,773.015  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "954.83,700.674 953.757,700.674 861.716,751.119 861.716,765.83 954.83,714.797  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M889.731,626.513c-0.184,0-0.369-0.014-0.553-0.043c-28.378-4.465-54.395-18.968-73.259-40.836 c-19.064-22.1-29.563-50.365-29.563-79.589c0-32.566,12.682-63.182,35.709-86.209c23.027-23.027,53.644-35.709,86.209-35.709 c16.457,0,32.424,3.224,47.457,9.582c14.518,6.141,27.556,14.931,38.752,26.126c23.027,23.027,35.709,53.643,35.709,86.209 c0,14.414-2.492,28.525-7.407,41.94c-4.749,12.962-11.633,24.955-20.463,35.646c-17.733,21.471-42.44,36.342-69.57,41.872 c-1.129,0.23-2.301-0.101-3.143-0.889s-1.25-1.935-1.094-3.077c2.13-15.662,7.322-34.191,14.193-50.954 c-5.399,1.537-11.761,2.486-17.109,0.888c-8.811-2.632-17.255-8.045-22.948-14.563c-4.626,4.695-10.366,9.619-17.118,14.684 c-2.858,2.143-5.698,3.953-8.48,5.405c6.653,15.414,12.367,32.743,16.083,44.919c0.358,1.173,0.087,2.447-0.717,3.373 C891.735,626.073,890.752,626.513,889.731,626.513z M908.273,391.244c-30.664,0-59.493,11.941-81.176,33.624 c-21.683,21.683-33.624,50.512-33.624,81.176c0,27.518,9.885,54.132,27.835,74.94c16.494,19.12,38.792,32.261,63.28,37.408 c-3.6-11.387-8.517-25.714-14.086-38.612c-10.453,3.382-20.097,1.281-26.84-5.976c-6.889-7.413-9.435-19.358-5.675-26.627 c2.29-4.428,6.553-6.575,11.697-5.889c7.813,1.042,15.62,10.346,24.447,29.203c2.321-1.239,4.708-2.776,7.131-4.593 c6.917-5.188,12.691-10.188,17.2-14.891c-4.052-7.388-3.551-14.59,1.504-19.646c4.648-4.648,10.243-5.664,13.607-2.473 c1.74,1.651,6.197,8.012-6.089,22.718c4.781,5.749,12.407,10.732,20.152,13.046c4.327,1.293,11.178,0.226,18.938-2.924 c10.318-22.206,18.114-28.479,22.869-29.801c2.481-0.691,4.865-0.322,6.892,1.065c2.863,1.958,4.26,4.869,3.936,8.195 c-0.54,5.535-5.82,11.045-10.154,14.693c-5.065,4.263-11.638,8.337-18.21,11.303c-7.16,15.977-12.812,34.277-15.55,50.2 c23.558-5.937,44.88-19.399,60.478-38.286c8.315-10.067,14.797-21.359,19.268-33.562c4.627-12.628,6.972-25.915,6.972-39.492 c0-30.664-11.941-59.493-33.625-81.176C967.767,403.186,938.938,391.244,908.273,391.244z M847.809,548.278 c-1.637,0-2.736,0.691-3.501,2.17c-2.137,4.132-0.787,12.751,4.567,18.513c3.394,3.653,9.294,7.112,18.687,4.294 c-10.119-21.489-16.483-24.598-18.82-24.91C848.413,548.3,848.102,548.278,847.809,548.278z M971.832,538.706 c-0.125,0-0.282,0.022-0.483,0.078c-2.938,0.817-8.137,6.544-14.121,17.569c9.185-5.583,15.6-12.179,15.959-15.857 c0.052-0.53,0.022-1.019-0.872-1.63C972.206,538.792,972.081,538.706,971.832,538.706z M908.666,534.168 c-0.534,0.045-1.898,0.455-3.669,2.226c-1.679,1.679-3.027,4.45-1.452,8.736C908.367,538.815,908.873,535.188,908.666,534.168z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E6"
    },
    d: "M411.973,443.871c27.442-6.82,47.206-31.993,47.206-60.399 c0-20.93-10.228-40.042-27.5-51.649c3.147-4.703,4.856-10.282,4.856-15.979c0-14.144-10.069-25.943-23.769-28.308 c-0.707-23.866-20.342-43.058-44.375-43.058c-23.767,0-43.59,19.232-44.358,42.945c-0.024,0.14-0.034,0.28-0.034,0.428 v133.963c-0.418,2.505-0.631,5.027-0.631,7.502c0,25.089,20.409,45.496,45.493,45.496 C388.272,474.813,405.789,462.159,411.973,443.871z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.356,278.427c-7.196,1.751-13.991,4.48-19.864,9.042 c-6.048,4.697-9.203,11.644-10.113,19.096c-0.452,3.697-0.016,7.504,0.156,11.207c0.093,1.998,0.12,3.996,0.013,5.994 c-0.089,1.661-0.242,2.673-0.945,4.871c-0.113,0.338-0.236,0.672-0.369,1.003c0.357-0.928-0.385,0.668-0.392,0.68 c-0.708,1.324-0.953,1.45-1.816,2.692c0.663-0.954-0.733,0.716-0.987,0.96c-0.343,0.329-0.713,0.629-1.081,0.929 c0.878-0.715-0.385,0.219-0.483,0.283c-0.661,0.437-1.361,0.809-2.069,1.162c-1.361,0.679,0.979-0.348-0.402,0.168 c-0.403,0.151-0.818,0.267-1.233,0.381c-0.263,0.068-0.529,0.127-0.796,0.176c1.381-0.279,0.278-0.052-0.08-0.042 c-1.219,0.036,1.215,0.281,0.093,0.045c-1.073-0.225,1.079,0.608,0.18,0.069c-2.497-1.496-5.846-0.573-7.303,1.915 c-1.482,2.531-0.577,5.811,1.915,7.303c7.163,4.291,16.895-1.888,21.199-7.608c0.346-0.441,0.357-0.47,0.033-0.088 c0.515-0.667,1.013-1.312,1.48-2.009c0.768-1.146,1.299-2.417,1.83-3.684c0.763-1.822,1.233-3.696,1.509-5.65 c0.633-4.471,0.413-8.879,0.185-13.371c-0.099-1.948-0.155-3.895-0.084-5.845c0.012-0.345,0.035-0.689,0.07-1.033 c0.139-1.668-0.188,1.028,0.073-0.582c0.154-0.948,0.391-1.88,0.659-2.801c0.089-0.296,0.185-0.59,0.287-0.882 c0.056-0.165,0.632-1.567,0.131-0.413c0.352-0.812,0.781-1.589,1.232-2.35c0.222-0.375,0.468-0.736,0.713-1.096 c0.814-1.196-0.694,0.823,0.212-0.301c0.543-0.675,1.145-1.301,1.76-1.91c0.517-0.511,1.07-0.985,1.629-1.449 c1.128-0.936-0.871,0.631,0.321-0.236c0.36-0.262,0.732-0.508,1.104-0.753c1.396-0.923,2.882-1.706,4.392-2.423 c0.282-0.132,0.565-0.261,0.85-0.386c1.421-0.637-0.991,0.394,0.466-0.189c0.89-0.356,1.795-0.673,2.703-0.98 c1.858-0.628,3.755-1.141,5.66-1.604c2.826-0.688,4.482-3.826,3.728-6.566C424.134,279.289,421.181,277.74,418.356,278.427 L418.356,278.427z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M396.849,300.316c-4.457-2.619-8.75-5.521-13.769-6.983 c-5.326-1.551-10.712-0.525-16.003,0.577c-1.934,0.403-3.865,0.819-5.82,1.111c1.456-0.217,0.118-0.03-0.158-0.002 c-0.513,0.051-1.029,0.076-1.544,0.093c-0.38,0.013-0.759,0.005-1.139-0.005c-0.338-0.009-2.046-0.219-0.445,0.014 c-0.873-0.127-1.722-0.372-2.55-0.67c1.313,0.471,0.107,0.029-0.156-0.104c-0.493-0.249-0.957-0.551-1.416-0.857 c-1.191-0.795,0.82,0.711-0.323-0.257c-0.494-0.418-0.947-0.882-1.395-1.348c-1.039-1.081-1.056-1.166-1.939-2.466 c-1.632-2.401-4.664-3.461-7.303-1.915c-2.381,1.395-3.553,4.893-1.915,7.303c3.074,4.524,6.749,8.192,11.969,10.066 c4.206,1.51,8.9,0.885,13.174,0.102c2.01-0.368,4.003-0.827,6.008-1.221c1.071-0.21,2.147-0.394,3.226-0.556 c-0.913,0.137,1.221-0.038,1.438-0.043c0.204-0.004,2.27,0.144,1.36,0.017c2.835,0.396,3.987,0.991,6.182,2.145 c2.443,1.285,4.751,2.816,7.129,4.214C397.409,313.03,402.778,303.801,396.849,300.316L396.849,300.316z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.44,423.069c-0.088-0.454-0.173-0.907-0.252-1.363c-0.038-0.218-0.254-1.713-0.069-0.321 c-0.108-0.814-0.178-1.632-0.23-2.451c-0.1-1.566-0.057-3.139,0.119-4.698c-0.203,1.788,0.1-0.355,0.199-0.79 c0.133-0.586,0.309-1.161,0.501-1.729c0.092-0.274,0.199-0.542,0.305-0.811c-0.614,1.546-0.24,0.586-0.076,0.247 c0.277-0.576,0.605-1.125,0.951-1.662c0.146-0.226,0.303-0.444,0.46-0.661c-0.975,1.352-0.42,0.539-0.175,0.243 c0.339-0.409,0.708-0.792,1.084-1.167c0.378-0.376,0.781-0.726,1.189-1.068c0.793-0.663-1.063,0.796-0.234,0.173 c0.289-0.217,0.588-0.421,0.887-0.624c0.919-0.623,1.89-1.167,2.876-1.678c0.507-0.263,1.024-0.507,1.542-0.747 c0.263-0.122,0.528-0.238,0.793-0.354c0.858-0.377-1.276,0.522,0.076-0.029c9.915-4.036,21.28-6.003,28.878-14.196 c1.781-1.921,3.308-4.125,4.406-6.504c1.219-2.642,0.773-5.729-1.915-7.303c-2.326-1.362-6.084-0.727-7.303,1.915 c-0.533,1.154-1.152,2.251-1.87,3.299c-0.193,0.282-0.879,1.168,0.108-0.101c-0.185,0.238-0.381,0.468-0.576,0.698 c-0.451,0.531-0.94,1.029-1.441,1.513c-0.427,0.412-0.878,0.799-1.335,1.177c-0.849,0.703,1.026-0.768,0.144-0.106 c-0.237,0.178-0.481,0.349-0.725,0.519c-1.064,0.744-2.189,1.398-3.335,2.007c-1.075,0.572-2.183,1.081-3.301,1.564 c1.659-0.717-0.327,0.123-0.72,0.277c-0.673,0.264-1.35,0.515-2.029,0.762c-2.421,0.882-4.874,1.675-7.31,2.516 c-5.249,1.813-10.364,3.87-14.748,7.339c-4.713,3.729-7.187,9.091-7.941,14.953c-0.514,3.999,0.004,8.066,0.771,12 c0.557,2.857,3.924,4.455,6.566,3.728C321.674,428.82,322.997,425.922,322.44,423.069L322.44,423.069z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.711,394.597c-0.183,8.617,4.424,15.405,10.997,20.53c1.703,1.328,3.442,2.601,5.199,3.856 c0.751,0.536,1.502,1.073,2.248,1.616c0.319,0.232,0.636,0.467,0.952,0.703c0.21,0.157,0.419,0.315,0.628,0.474 c-0.562-0.436-0.613-0.474-0.152-0.113c1.414,1.114,2.758,2.312,3.998,3.617c0.261,0.275,0.51,0.561,0.759,0.847 c0.164,0.191,0.324,0.385,0.482,0.582c-0.446-0.586-0.496-0.645-0.151-0.179c0.521,0.714,0.974,1.474,1.39,2.253 c1.372,2.562,4.865,3.343,7.303,1.915c2.578-1.51,3.289-4.738,1.915-7.303c-3.61-6.742-10.224-10.871-16.225-15.243 c-0.312-0.227-2.237-1.697-1.103-0.812c-0.707-0.552-1.396-1.127-2.07-1.718c-0.662-0.58-1.293-1.194-1.904-1.827 c-0.259-0.268-0.506-0.547-0.752-0.826c-0.162-0.186-0.321-0.375-0.477-0.567c0.451,0.599,0.504,0.667,0.159,0.203 c-0.44-0.592-0.827-1.221-1.192-1.861c-0.184-0.322-0.346-0.656-0.508-0.99c-0.241-0.532-0.209-0.452,0.094,0.242 c-0.092-0.236-0.178-0.474-0.259-0.715c-0.302-0.868-0.496-1.77-0.647-2.676c0.237,1.421,0.034,0.026,0.015-0.242 c-0.041-0.588-0.034-1.178-0.021-1.767c0.062-2.91-2.475-5.338-5.338-5.338C342.092,389.259,339.772,391.689,339.711,394.597 L339.711,394.597z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M428.875,452.438c-1.097-0.817,0.885,0.718-0.218-0.176c-0.338-0.274-0.665-0.56-0.993-0.846 c-0.697-0.608-1.364-1.251-2.023-1.899c-1.572-1.547-3.034-3.205-4.449-4.895c-2.479-2.963-5.068-6.658-7.466-10.527 c-1.106-1.784-2.142-3.611-3.121-5.468c-0.455-0.862-0.884-1.736-1.303-2.616c-0.198-0.417-0.387-0.839-0.576-1.261 c-0.473-1.06,0.319,0.9-0.148-0.524c-0.455-1.389-0.802-2.812-1.1-4.241c-0.158-0.758-0.287-1.522-0.408-2.287 c-0.213-1.349,0.146,1.213-0.027-0.156c-0.068-0.535-0.121-1.073-0.172-1.61c-0.335-3.501-0.307-7.034-0.006-10.536 c0.037-0.429,0.083-0.857,0.13-1.285c0.025-0.23,0.221-1.677,0.028-0.29c0.119-0.851,0.268-1.698,0.427-2.543 c0.342-1.81,0.802-3.596,1.348-5.354c0.247-0.797,0.529-1.583,0.824-2.363c0.082-0.216,0.622-1.51,0.084-0.251 c0.16-0.375,0.333-0.745,0.505-1.115c0.732-1.566,1.606-3.061,2.586-4.483c0.143-0.207,0.951-1.27,0.094-0.168 c0.237-0.304,0.487-0.598,0.738-0.891c0.497-0.581,1.034-1.125,1.585-1.655c0.292-0.28,2.134-1.741,0.956-0.863 c0.711-0.53,1.469-0.992,2.243-1.422c0.335-0.186,0.681-0.353,1.026-0.519c1.195-0.575-1.093,0.418,0.154-0.064 c2.712-1.048,4.558-3.548,3.728-6.566c-0.714-2.593-3.849-4.778-6.566-3.728c-15.024,5.806-20.378,22.549-20.783,37.409 c-0.197,7.198,0.77,14.703,3.722,21.309c3.699,8.278,9.087,15.97,14.975,22.826c2.649,3.084,5.557,5.847,8.818,8.276 c2.339,1.742,5.956,0.386,7.303-1.915C432.384,457.02,431.203,454.172,428.875,452.438L428.875,452.438z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.464,315.405c1.857,1.062,3.661,2.203,5.416,3.427c2.011,1.402,2.726,1.995,4.745,3.775 c1.585,1.397,3.084,2.89,4.524,4.435c0.718,0.771,1.407,1.568,2.086,2.373c0.339,0.402,0.668,0.813,0.997,1.224 c0.391,0.495,0.434,0.551,0.13,0.167c0.211,0.28,0.419,0.561,0.626,0.845c2.592,3.532,4.759,7.365,6.531,11.368 c-0.419-0.947,0.26,0.641,0.272,0.671c0.196,0.49,0.379,0.985,0.562,1.48c0.367,0.993,0.693,2,1.005,3.011 c0.682,2.208,1.2,4.464,1.612,6.736c0.52,2.865,3.953,4.447,6.566,3.728c2.99-0.823,4.247-3.706,3.728-6.566 c-3.522-19.425-16.416-36.169-33.411-45.891c-2.526-1.445-5.824-0.611-7.303,1.915 C309.089,310.594,309.942,313.963,312.464,315.405L312.464,315.405z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E6"
    },
    d: "M266.102,474.813c25.084,0,45.493-20.407,45.493-45.496c0-2.475-0.213-4.996-0.631-7.502 V287.852c0-0.148-0.011-0.289-0.034-0.428c-0.768-23.714-20.592-42.945-44.358-42.945 c-24.033,0-43.667,19.192-44.375,43.058c-13.701,2.365-23.769,14.163-23.769,28.308c0,5.697,1.709,11.276,4.855,15.979 c-17.272,11.607-27.5,30.719-27.5,51.649c0,28.406,19.763,53.579,47.206,60.399 C229.173,462.159,246.69,474.813,266.102,474.813z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.768,288.722c1.75,0.426,3.484,0.905,5.2,1.453c0.764,0.244,1.52,0.514,2.273,0.79 c0.447,0.164,0.888,0.34,1.33,0.517c-1.109-0.443,0.324,0.146,0.453,0.204c1.533,0.687,3.011,1.49,4.438,2.376 c0.631,0.392,1.239,0.819,1.839,1.256c-1.005-0.731,0.158,0.137,0.3,0.255c0.336,0.279,0.657,0.574,0.978,0.869 c0.532,0.49,1.028,1.016,1.513,1.552c0.291,0.321,0.562,0.658,0.834,0.995c-0.795-0.987,0.076,0.163,0.185,0.324 c0.411,0.604,0.772,1.241,1.118,1.884c0.211,0.392,0.397,0.797,0.583,1.202c-0.522-1.138,0.07,0.244,0.131,0.413 c0.265,0.736,0.468,1.493,0.654,2.253c0.116,0.473,0.204,0.952,0.291,1.43c0.293,1.604-0.098-1.082,0.073,0.582 c0.215,2.096,0.105,4.236,0.012,6.336c-0.177,3.991-0.506,7.975-0.096,11.962c0.232,2.252,0.615,4.467,1.365,6.605 c0.45,1.281,1.02,2.533,1.66,3.73c0.262,0.491,0.573,0.954,0.883,1.416c0.188,0.28,1.679,2.348,0.934,1.276 c4.145,5.962,14.254,12.282,21.466,7.962c2.492-1.493,3.397-4.773,1.915-7.303c-1.458-2.488-4.806-3.411-7.303-1.915 c-0.48,0.272-0.321,0.22,0.478-0.155c-0.404,0.152-1.356,0.151,0.146,0.033c-0.237,0.011-0.474,0.01-0.711-0.003 c-1.284-0.038,1.218,0.242-0.114-0.027c-0.702-0.142-1.382-0.383-2.051-0.633c1.16,0.434-0.245-0.142-0.404-0.221 c-0.426-0.212-0.835-0.456-1.243-0.698c-0.273-0.167-0.543-0.34-0.808-0.52c-1.304-0.862,0.753,0.662-0.453-0.32 c-0.724-0.59-1.374-1.261-1.984-1.965c0.369,0.497,0.381,0.504,0.037,0.02c-0.278-0.36-0.556-0.72-0.835-1.08 c0.268,0.308,0.214,0.206-0.163-0.304c-0.307-0.458-0.568-0.945-0.828-1.431c-0.797-1.49,0.273,0.862-0.326-0.698 c-0.318-0.829-0.54-1.692-0.743-2.554c-0.077-0.347-0.145-0.695-0.206-1.045c-0.315-1.698,0.088,1.023-0.09-0.702 c-0.204-1.981-0.175-3.985-0.113-5.973c0.122-3.923,0.58-7.868,0.252-11.792c-0.629-7.535-3.97-14.473-9.823-19.332 c-5.799-4.814-12.951-7.552-20.207-9.317c-2.825-0.687-5.778,0.862-6.566,3.728 C209.286,284.896,210.941,288.034,213.768,288.722L213.768,288.722z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.501,309.534c2.226-1.308,4.401-2.703,6.658-3.958c2.41-1.341,3.294-1.739,6.121-2.31 c1.672-0.337-0.983,0.055,0.757-0.077c0.768-0.058,1.54-0.029,2.308,0.012c1.887,0.1-0.814-0.163,0.737,0.07 c0.618,0.093,1.234,0.203,1.85,0.314c2.176,0.393,4.332,0.891,6.502,1.314c4.379,0.854,8.868,1.368,13.224,0.094 c5.374-1.572,9.275-5.688,12.331-10.184c1.638-2.41,0.466-5.908-1.915-7.303c-2.639-1.546-5.671-0.487-7.303,1.915 c-0.799,1.175-0.847,1.235-1.592,2.086c-0.331,0.378-0.687,0.733-1.044,1.086c-0.164,0.163-1.673,1.405-0.669,0.647 c-0.768,0.579-1.611,1.047-2.481,1.453c1.261-0.589,0.11-0.085-0.164,0.005c-0.477,0.155-0.968,0.26-1.459,0.359 c-1.279,0.257,1.237-0.116-0.063,0.006c-0.501,0.047-1.005,0.053-1.508,0.055c-0.906,0.004-1.811-0.081-2.71-0.183 c1.474,0.167,0.095,0.005-0.176-0.038c-0.546-0.087-1.089-0.19-1.632-0.293c-0.988-0.187-1.971-0.398-2.954-0.604 c-5.333-1.118-10.512-2.059-15.922-0.802c-5.215,1.211-9.742,4.449-14.283,7.118 C232.184,303.801,237.553,313.03,243.501,309.534L243.501,309.534z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.816,425.907c1.348-6.908,1.539-13.966-1.698-20.391 c-2.374-4.712-6.859-8.135-11.506-10.405c-4.858-2.372-10.063-3.904-15.146-5.698c-1.168-0.412-2.328-0.845-3.48-1.303 c-0.286-0.114-0.571-0.232-0.855-0.349c1.507,0.624,0.464,0.193,0.147,0.054c-0.651-0.286-1.293-0.591-1.931-0.905 c-1.079-0.533-2.129-1.124-3.149-1.763c-0.505-0.316-0.995-0.654-1.479-1.001c-0.283-0.203-1.139-0.887,0.135,0.117 c-0.311-0.245-0.611-0.502-0.909-0.762c-0.524-0.456-1.017-0.945-1.496-1.447c-0.323-0.339-1.777-2.179-0.712-0.767 c-0.886-1.175-1.612-2.462-2.228-3.796c-1.219-2.642-4.977-3.277-7.303-1.915c-2.688,1.575-3.135,4.661-1.915,7.303 c5,10.831,16.534,14.88,27.026,18.434c1.158,0.392,2.313,0.79,3.464,1.203c0.565,0.203,1.128,0.414,1.689,0.628 c0.434,0.166,2.634,1.08,0.914,0.348c2.153,0.916,4.24,2,6.148,3.359c0.303,0.216,1.101,0.865-0.223-0.183 c0.21,0.166,0.413,0.34,0.615,0.514c0.403,0.347,0.784,0.719,1.155,1.099c0.371,0.381,0.714,0.787,1.047,1.202 c-1.18-1.472,0.124,0.272,0.378,0.697c0.284,0.476,0.529,0.974,0.76,1.477c-0.775-1.684,0.033,0.174,0.174,0.618 c0.186,0.583,0.325,1.18,0.451,1.779c0.066,0.314,0.116,0.63,0.167,0.946c-0.277-1.726-0.034-0.131-0.002,0.247 c0.113,1.357,0.082,2.723-0.005,4.081c-0.044,0.687-0.121,1.372-0.204,2.056c0.17-1.392-0.033,0.101-0.069,0.321 c-0.075,0.456-0.164,0.909-0.252,1.363c-0.557,2.853,0.766,5.751,3.728,6.566 C318.892,430.362,322.258,428.764,322.816,425.907L322.816,425.907z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.575,394.597c0.019,0.874-0.009,1.739-0.091,2.61c0.132-1.409-0.005-0.083-0.058,0.193 c-0.099,0.513-0.24,1.016-0.388,1.517c-0.108,0.366-0.242,0.723-0.376,1.08c0.503-1.34,0.061-0.175-0.069,0.093 c-0.377,0.775-0.838,1.506-1.324,2.216c-0.159,0.232-0.951,1.217-0.055,0.096c-0.232,0.29-0.478,0.567-0.723,0.845 c-0.58,0.656-1.208,1.268-1.847,1.865c-0.652,0.609-1.337,1.182-2.028,1.746c-0.194,0.158-1.243,0.973-0.14,0.124 c-0.413,0.318-0.833,0.628-1.252,0.938c-6.083,4.496-12.859,8.597-16.542,15.475c-1.374,2.565-0.663,5.793,1.915,7.303 c2.439,1.429,5.931,0.647,7.303-1.915c0.359-0.67,0.749-1.314,1.173-1.944c0.15-0.223,0.942-1.245,0.066-0.13 c0.312-0.397,0.647-0.775,0.983-1.15c1.198-1.337,2.559-2.523,3.951-3.652c0.191-0.155,1.25-0.973,0.153-0.131 c0.416-0.32,0.839-0.632,1.261-0.944c0.742-0.548,1.494-1.083,2.244-1.619c1.493-1.066,2.987-2.131,4.441-3.251 c3.355-2.583,6.382-5.309,8.725-8.88c2.399-3.656,3.445-8.149,3.353-12.485c-0.062-2.909-2.381-5.338-5.338-5.338 C287.05,389.259,284.513,391.687,284.575,394.597L284.575,394.597z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.476,461.656c7.262-5.41,12.913-12.779,17.812-20.324 c4.249-6.544,7.793-13.411,8.957-21.188c2.144-14.319,0.073-31.757-10.673-42.432c-2.682-2.664-5.864-4.524-9.365-5.877 c-2.718-1.05-5.853,1.135-6.566,3.728c-0.83,3.018,1.017,5.518,3.728,6.566c1.25,0.483-1.055-0.489,0.154,0.064 c0.349,0.159,0.687,0.339,1.026,0.519c0.671,0.356,1.31,0.771,1.936,1.202c1.074,0.74-0.891-0.736,0.125,0.081 c0.296,0.237,0.578,0.491,0.86,0.744c0.664,0.595,1.275,1.245,1.864,1.913c0.255,0.289,0.497,0.59,0.738,0.891 c-0.871-1.085-0.055-0.04,0.093,0.168c0.457,0.643,0.872,1.315,1.274,1.994c0.41,0.691,0.779,1.405,1.136,2.124 c0.181,0.365,0.349,0.735,0.517,1.106c0.239,0.547,0.22,0.499-0.055-0.143c0.104,0.255,0.205,0.511,0.304,0.768 c1.283,3.295,2.084,6.769,2.599,10.261c-0.204-1.384,0.001,0.059,0.028,0.29c0.05,0.428,0.09,0.856,0.13,1.285 c0.08,0.855,0.131,1.712,0.173,2.57c0.09,1.831,0.075,3.667-0.006,5.498c-0.037,0.824-0.1,1.647-0.173,2.469 c-0.036,0.407-0.359,2.915-0.14,1.376c-0.232,1.636-0.563,3.258-0.97,4.859c-0.176,0.693-0.381,1.378-0.596,2.06 c-0.08,0.254-0.505,1.371,0.032,0.112c-0.179,0.42-0.369,0.834-0.558,1.249c-0.897,1.964-1.919,3.871-2.983,5.748 c-4.413,7.782-8.937,14.16-15.577,20.082c-0.325,0.289-0.659,0.568-0.993,0.846c-1.09,0.907,0.878-0.64-0.218,0.176 c-2.328,1.734-3.509,4.582-1.915,7.303C205.52,462.042,209.136,463.399,211.476,461.656L211.476,461.656z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.11,306.187c-16.996,9.722-29.89,26.466-33.411,45.891 c-0.518,2.86,0.738,5.744,3.728,6.566c2.613,0.719,6.047-0.863,6.566-3.728c0.381-2.102,0.867-4.176,1.46-6.228 c0.294-1.017,0.629-2.022,0.978-3.022c0.174-0.499,0.362-0.992,0.549-1.486c0.065-0.17,0.828-2.005,0.463-1.162 c1.737-4.022,3.971-7.818,6.531-11.368c0.01-0.014,1.045-1.393,0.431-0.599c0.322-0.416,0.654-0.824,0.986-1.232 c0.665-0.816,1.361-1.608,2.065-2.39c1.532-1.7,3.176-3.297,4.88-4.824c1.849-1.656,2.612-2.242,4.31-3.467 c1.878-1.354,3.842-2.585,5.85-3.735c2.522-1.442,3.375-4.811,1.915-7.303C322.933,305.577,319.636,304.742,317.11,306.187 L317.11,306.187z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 532.811,
    y: 217.132,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.604 449.0193)",
    style: {
      fill: "#862461"
    },
    width: 15.837,
    height: 21.042
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6E6F"
    },
    d: "M538.288,153.197c-19.886-19.887-52.128-19.887-72.016,0c-19.886,19.886-19.886,52.129,0,72.015 c19.887,19.886,52.129,19.886,72.016,0C558.175,205.326,558.175,173.083,538.288,153.197z M527.739,214.663 c-14.06,14.059-36.856,14.059-50.917,0c-14.06-14.061-14.06-36.856,0-50.917c14.06-14.059,36.856-14.059,50.917,0 C541.799,177.806,541.799,200.602,527.739,214.663z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 539.396,
    y: 233.341,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.428 460.7048)",
    style: {
      fill: "#6D6E6F"
    },
    width: 25.998,
    height: 11.954
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 568.576,
    y: 234.516,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.2113 486.7228)",
    style: {
      fill: "#E7AD4B"
    },
    width: 19.69,
    height: 61.657
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M502.28,234.952c-12.22,0-23.708-4.759-32.349-13.399c-17.836-17.837-17.836-46.86,0-64.698 c8.641-8.641,20.129-13.399,32.349-13.399c12.22,0,23.708,4.759,32.349,13.399c8.641,8.641,13.4,20.129,13.4,32.349 c0,12.22-4.759,23.708-13.4,32.349C525.989,230.194,514.5,234.952,502.28,234.952z M502.28,145.235 c-11.744,0-22.786,4.574-31.091,12.878c-17.143,17.144-17.143,45.038,0,62.181c8.305,8.305,19.347,12.878,31.091,12.878 c11.744,0,22.786-4.574,31.091-12.878c8.305-8.304,12.878-19.346,12.878-31.09c0-11.744-4.574-22.786-12.878-31.091 C525.066,149.809,514.025,145.235,502.28,145.235z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#808083"
    },
    points: "1542.055,374.401 1416.793,320.842 1291.531,374.401 1416.793,427.961  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1416.793,431.831l-134.314-57.43l134.314-57.43l134.314,57.43L1416.793,431.831z  M1300.582,374.402l116.211,49.689l116.211-49.689l-116.211-49.689L1300.582,374.402z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M1525.808,138.605c-16.415,0-31.297,6.528-42.223,17.111l42.223,43.587V138.605z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M1480.912,172.193c-11.387,11.032-18.477,26.475-18.477,43.586c0,13.078,4.151,25.182,11.188,35.09 l49.511-35.09L1480.912,172.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M1598.454,218.387c-0.008-2.706-0.205-5.366-0.548-7.978c-0.132-0.991-0.286-1.974-0.464-2.949 c-0.383-2.109-0.871-4.181-1.464-6.208c-0.254-0.874-0.527-1.736-0.82-2.594c-0.639-1.876-1.365-3.71-2.175-5.498 c-0.351-0.783-0.716-1.551-1.099-2.314c-0.846-1.683-1.765-3.324-2.756-4.917c-0.435-0.699-0.876-1.393-1.337-2.073 c-1.145-1.679-2.369-3.303-3.668-4.86c-0.515-0.618-1.042-1.228-1.583-1.828c-1.212-1.343-2.486-2.629-3.811-3.865 c-0.588-0.547-1.19-1.084-1.799-1.609c-1.38-1.19-2.809-2.319-4.291-3.383c-0.661-0.48-1.33-0.947-2.012-1.397 c-1.552-1.029-3.149-1.996-4.795-2.881c-0.741-0.4-1.494-0.786-2.254-1.157c-1.942-0.946-3.941-1.794-5.991-2.535 c-0.842-0.305-1.688-0.596-2.546-0.864c-1.994-0.625-4.03-1.152-6.103-1.576c-0.956-0.193-1.921-0.366-2.892-0.518 c-2.296-0.355-4.637-0.571-7.008-0.665c-0.825-0.032-1.651-0.063-2.484-0.063c-0.668,0-1.205,0.54-1.205,1.205v2.549v7.674v3.411 v7.674v3.411v8.53v3.41v7.675v3.411v7.673v3.412v1.25l-4.291,3.037l-11.71,8.299l-26.355,18.68l-6.647,4.714 c-0.261,0.183-0.439,0.464-0.492,0.778c-0.053,0.316,0.022,0.641,0.206,0.902c0.075,0.105,0.158,0.204,0.232,0.307 c1.071,1.487,2.212,2.908,3.398,4.281c0.527,0.609,1.057,1.214,1.607,1.802c1.238,1.327,2.533,2.59,3.875,3.796 c0.602,0.541,1.211,1.067,1.829,1.582c1.566,1.3,3.176,2.539,4.854,3.675c0.683,0.462,1.387,0.891,2.088,1.325 c1.598,0.993,3.235,1.915,4.915,2.761c0.763,0.379,1.528,0.755,2.305,1.104c1.798,0.813,3.644,1.521,5.516,2.159 c0.857,0.291,1.717,0.57,2.587,0.822c2.032,0.597,4.093,1.107,6.186,1.492c0.98,0.179,1.969,0.32,2.958,0.449 c2.628,0.353,5.29,0.546,7.975,0.555c0.057,0.003,0.113,0.005,0.17,0.005c1.117,0,2.225-0.033,3.326-0.092 c2.988-0.158,5.919-0.534,8.781-1.105c1.52-0.303,3.015-0.67,4.491-1.081c4.517-1.258,8.834-3.003,12.875-5.198 c4.109-2.235,7.932-4.935,11.414-8.006c1.96-1.728,3.809-3.575,5.535-5.535c3.074-3.484,5.772-7.303,8.006-11.417 c2.197-4.039,3.94-8.356,5.2-12.871c0.411-1.479,0.778-2.974,1.081-4.495c0.569-2.859,0.945-5.79,1.105-8.778 c0.058-1.104,0.091-2.211,0.091-3.327C1598.458,218.502,1598.454,218.443,1598.454,218.387z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1474.348,
    y: 760.162,
    style: {
      fill: "#A5A5A9"
    },
    width: 245.438,
    height: 160.942
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1495.619,
    y: 782.157,
    style: {
      fill: "#FFFFFF"
    },
    width: 202.895,
    height: 116.952
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.47,
    y: 921.104,
    style: {
      fill: "#59595C"
    },
    width: 73.194,
    height: 20.682
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1538.979,
    y: 941.786,
    style: {
      fill: "#A5A5A9"
    },
    width: 116.174,
    height: 11.155
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M1707.585,908.904h-221.037V772.362h221.037V908.904z M1488.327,907.125h217.478V774.141 h-217.478V907.125z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1600.724,
    y: 841.151,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -128.7955 1382.9595)",
    style: {
      fill: "#862461"
    },
    width: 8.744,
    height: 11.618
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6E6F"
    },
    d: "M1603.749,805.851c-10.98-10.98-28.782-10.98-39.762,0c-10.98,10.98-10.98,28.782,0,39.762 c10.981,10.98,28.782,10.98,39.762,0C1614.729,834.633,1614.729,816.83,1603.749,805.851z M1597.924,839.788 c-7.763,7.763-20.349,7.763-28.113,0c-7.763-7.764-7.763-20.35,0-28.113c7.763-7.762,20.35-7.762,28.113,0 C1605.687,819.438,1605.687,832.024,1597.924,839.788z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1604.36,
    y: 850.101,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -131.4215 1389.536)",
    style: {
      fill: "#6D6E6F"
    },
    width: 14.354,
    height: 6.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1620.471,
    y: 850.749,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -137.4034 1403.8082)",
    style: {
      fill: "#E7AD4B"
    },
    width: 10.872,
    height: 34.043
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1583.868,851.389c-6.853,0-13.297-2.669-18.143-7.515c-10.004-10.004-10.004-26.281,0-36.285 c4.846-4.846,11.289-7.515,18.143-7.515s13.297,2.669,18.142,7.515l0,0l0,0c4.846,4.846,7.516,11.289,7.516,18.143 c0,6.853-2.669,13.297-7.516,18.143C1597.164,848.72,1590.721,851.389,1583.868,851.389z M1583.868,801.853 c-6.378,0-12.375,2.484-16.885,6.994c-9.31,9.31-9.31,24.459,0,33.769c4.51,4.51,10.506,6.994,16.885,6.994 c6.378,0,12.375-2.484,16.884-6.994c4.51-4.51,6.994-10.506,6.994-16.885c0-6.378-2.484-12.374-6.994-16.884l0,0 C1596.242,804.337,1590.246,801.853,1583.868,801.853z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7AD4B"
    },
    points: "221.225,280.628 221.225,335.211 253.557,260.423 221.225,260.423 221.225,205.839  188.893,280.628  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M1366.335,532.138c0-7.759-6.29-14.049-14.048-14.049c-7.759,0-14.049,6.29-14.049,14.049 c0,5.564,3.236,10.373,7.927,12.648V827.83h12.242V544.785C1363.1,542.51,1366.335,537.702,1366.335,532.138z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1346.166,
    y: 551.442,
    style: {
      fill: "#471132"
    },
    width: 128.07,
    height: 129.954
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#862461"
    },
    points: "1416.793,571.218 1474.236,551.442 1474.236,661.228 1416.793,661.228  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B1789D"
    },
    points: "1544.792,571.218 1416.793,571.218 1416.793,701.172 1542.53,701.172 1486.671,637.484  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421.995,
    y: 859.985,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -535.3129 840.0897)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.937,
    y: 850.522,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -524.2703 839.3875)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M437.155,835.706l3.155,1.647l1.024-1.961c-1.085-0.485-2.138-1.035-3.154-1.648L437.155,835.706z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.228,
    y: 897.838,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -579.4834 842.8989)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.879,
    y: 841.059,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -513.2277 838.6851)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.053,
    y: 869.449,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -546.3555 840.7921)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.17,
    y: 888.375,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -568.4408 842.1966)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.111,
    y: 878.912,
    transform: "matrix(0.4629 -0.8864 0.8864 0.4629 -557.3982 841.4943)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M474.004,828.877l0.59,0.493l2.281-2.732l-0.591-0.493 C475.582,827.099,474.82,828.011,474.004,828.877z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.029,
    y: 817.51,
    transform: "matrix(0.5939 -0.8045 0.8045 0.5939 -440.427 765.9738)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.688,
    y: 826.099,
    transform: "matrix(0.594 -0.8045 0.8045 0.594 -449.9069 764.293)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M308.764,905.66l3.154,1.648l2.184-4.182c-1.178-0.257-2.294-0.727-3.293-1.382L308.764,905.66z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.346,
    y: 834.687,
    transform: "matrix(0.594 -0.8045 0.8045 0.594 -459.3943 762.729)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.613,
    y: 835.848,
    transform: "matrix(0.6409 -0.7676 0.7676 0.6409 -468.6113 677.1195)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.418,
    y: 829.006,
    transform: "matrix(0.6409 -0.7676 0.7676 0.6409 -466.3034 668.3785)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M404.069,906.75l-3.155-1.647l-2.75,5.265c1.112,0.447,2.135,1.096,3.016,1.913L404.069,906.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.005,
    y: 843.275,
    transform: "matrix(0.5939 -0.8045 0.8045 0.5939 -468.8799 761.1312)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.809,
    y: 842.69,
    transform: "matrix(0.6409 -0.7677 0.7677 0.6409 -470.924 685.8902)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M384.019,914.493l-1.19,3.354l1.947,0.69c0.113-1.205,0.451-2.365,0.979-3.429L384.019,914.493z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.66,
    y: 939.401,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -677.306 764.4451)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M325.181,897.401l3.986,1.414l1.19-3.354l-4.395-1.559 C325.92,895.122,325.649,896.306,325.181,897.401z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.691,
    y: 895.958,
    transform: "matrix(0.3343 -0.9425 0.9425 0.3343 -623.7762 915.9464)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.814,
    y: 903.095,
    transform: "matrix(0.3343 -0.9425 0.9425 0.3343 -617.1066 939.6505)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.752,
    y: 899.527,
    transform: "matrix(0.3343 -0.9425 0.9425 0.3343 -620.4411 927.8049)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595C"
    },
    d: "M280.615,967.239l-3.154-1.648l-1.069,2.047c1.088,0.478,2.141,1.029,3.154,1.648L280.615,967.239z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.775,
    y: 958.327,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -699.387 765.8338)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.717,
    y: 948.864,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -688.3478 765.1459)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.37,
    y: 808.922,
    transform: "matrix(0.594 -0.8045 0.8045 0.594 -430.9407 767.5439)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.545,
    y: 920.476,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -655.2185 763.0187)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.876,
    y: 906.664,
    transform: "matrix(0.3343 -0.9425 0.9425 0.3343 -613.7712 951.522)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.487,
    y: 911.013,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -644.179 762.3304)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.602,
    y: 929.939,
    transform: "matrix(0.463 -0.8864 0.8864 0.463 -666.2599 763.7192)",
    style: {
      fill: "#59595C"
    },
    width: 7.117,
    height: 3.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.937,
    y: 910.233,
    transform: "matrix(0.3343 -0.9425 0.9425 0.3343 -610.4364 963.3759)",
    style: {
      fill: "#59595C"
    },
    width: 3.559,
    height: 7.117
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M279.546,969.286c-1.012-0.619-2.066-1.17-3.154-1.648c-5.222-2.295-11.222-2.917-17.169-1.363 c-14.013,3.663-22.404,17.994-18.74,32.007c3.666,14.013,17.995,22.406,32.007,18.742c14.018-3.663,22.407-17.993,18.744-32.01 C289.448,978.187,285.126,972.7,279.546,969.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M325.649,891.089c-1.367-5.23-6.715-8.361-11.944-6.993c-5.23,1.367-8.36,6.714-6.993,11.943 c0.638,2.44,2.143,4.422,4.098,5.705c0.998,0.655,2.115,1.125,3.293,1.382c1.458,0.318,3.01,0.309,4.553-0.094 c3.046-0.796,5.378-2.944,6.526-5.631c0.468-1.095,0.739-2.279,0.781-3.499C325.993,892.976,325.895,892.031,325.649,891.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M401.181,912.281c-0.881-0.817-1.904-1.466-3.016-1.913c-1.879-0.755-4.008-0.937-6.118-0.385 c-2.852,0.746-5.078,2.677-6.292,5.126c-0.527,1.064-0.866,2.224-0.979,3.429c-0.104,1.107-0.02,2.251,0.278,3.39 c1.367,5.229,6.715,8.36,11.944,6.993c5.229-1.368,8.36-6.715,6.993-11.945C403.502,915.105,402.501,913.505,401.181,912.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M480.945,801.792c-4.026-15.396-19.769-24.616-35.166-20.591 c-15.396,4.027-24.614,19.771-20.589,35.167c1.976,7.564,6.785,13.632,12.99,17.377c1.016,0.613,2.069,1.164,3.154,1.648 c5.773,2.579,12.428,3.291,19.021,1.566c5.42-1.416,10.069-4.288,13.649-8.082c0.817-0.865,1.578-1.777,2.28-2.733 C481.243,819.386,483.23,810.533,480.945,801.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M507.88,846.596c-5.229,1.367-8.36,6.714-6.993,11.944c1.368,5.229,6.714,8.36,11.944,6.993 c5.23-1.367,8.36-6.714,6.993-11.943C518.458,848.36,513.11,845.229,507.88,846.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M562.925,796.787c-1.367-5.23-6.715-8.362-11.944-6.993c-5.229,1.366-8.359,6.714-6.993,11.943 c1.368,5.23,6.715,8.36,11.944,6.994C561.161,807.363,564.291,802.015,562.925,796.787z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 108.7472 2052.8303)",
    style: {
      fill: "#E7AD4B"
    },
    cx: 1260.781,
    cy: 962.507,
    rx: 65.404,
    ry: 65.405
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#59595B"
    },
    cx: 1260.781,
    cy: 962.507,
    r: 39.443
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1260.781,1005.508c-23.711,0-43.002-19.29-43.002-43.001s19.29-43.001,43.002-43.001 c23.711,0,43.001,19.29,43.001,43.001S1284.492,1005.508,1260.781,1005.508z M1260.781,926.622 c-19.787,0-35.884,16.098-35.884,35.884c0,19.786,16.098,35.884,35.884,35.884s35.884-16.098,35.884-35.884 C1296.665,942.72,1280.567,926.622,1260.781,926.622z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1234.115,
    cy: 933.57,
    r: 18.769
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M685.921,1011.676c-4.875,0-9.639-2.454-12.362-6.897l-56.663-92.447 c-2.015-3.287-2.627-7.161-1.723-10.908c0.905-3.752,3.221-6.926,6.522-8.937l4.323-2.635 c6.802-4.146,15.717-1.998,19.875,4.786l56.663,92.447c2.015,3.287,2.627,7.161,1.723,10.908 c-0.905,3.752-3.221,6.926-6.521,8.938l-4.324,2.635C691.088,1010.995,688.489,1011.676,685.921,1011.676z M633.546,894.854 c-1.306,0-2.629,0.347-3.823,1.074l-4.323,2.635c-1.674,1.021-2.849,2.629-3.307,4.53c-0.457,1.895-0.147,3.855,0.872,5.519 l56.663,92.447c2.113,3.447,6.645,4.536,10.103,2.428l4.324-2.635c1.674-1.02,2.849-2.629,3.307-4.529 c0.457-1.895,0.148-3.856-0.872-5.519l-56.663-92.447C638.443,896.1,636.023,894.854,633.546,894.854z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M611.934,890.964c-4.875,0-9.638-2.454-12.362-6.897l-5.828-9.508 c-2.015-3.287-2.627-7.161-1.723-10.908c0.905-3.752,3.221-6.926,6.522-8.937l4.324-2.635 c6.802-4.145,15.717-1.998,19.875,4.786l5.828,9.508c2.015,3.288,2.627,7.162,1.723,10.908 c-0.905,3.752-3.221,6.925-6.522,8.937l-4.323,2.635C617.101,890.283,614.502,890.964,611.934,890.964z M610.395,857.081 c-1.307,0-2.629,0.347-3.823,1.075l-4.324,2.635c-1.674,1.02-2.848,2.629-3.307,4.529c-0.457,1.895-0.148,3.855,0.872,5.519 l5.828,9.508c2.112,3.447,6.645,4.536,10.103,2.428l4.323-2.635c1.674-1.021,2.849-2.629,3.307-4.529 c0.457-1.895,0.148-3.855-0.872-5.519l-5.827-9.508C615.291,858.327,612.871,857.081,610.395,857.081z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 656.434,
    y: 885.552,
    transform: "matrix(0.8526 -0.5226 0.5226 0.8526 -399.2317 484.9505)",
    style: {
      fill: "#59595B"
    },
    width: 7.117,
    height: 129.177
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M709.182,1030.403l-34.388-23.391l29.196-17.795L709.182,1030.403z M687.931,1007.34 l12.218,8.311l-1.845-14.633L687.931,1007.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M337.086,527.64h-1.064c0,0-87.824-20.397-136.302,0v134.349c48.477-20.398,136.302,0,136.302,0 h1.064c0,0,87.824-20.398,136.301,0V527.64C424.91,507.243,337.086,527.64,337.086,527.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M476.234,666.275l-3.951-1.662c-29.622-12.464-29.621-12.464-84.892-7.445 c-27.513,2.499-49.443,7.543-49.661,7.594l-0.318,0.074l-1.716,0l-0.318-0.074c-0.218-0.051-22.148-5.095-49.661-7.594 c-55.27-5.019-55.27-5.019-84.892,7.445l-3.951,1.662V525.75l1.743-0.733c20.539-8.642,50.043-11.286,87.692-7.86 c26.053,2.371,47.184,6.997,50.033,7.637h0.426c2.848-0.64,23.979-5.266,50.033-7.637c37.649-3.426,67.153-0.782,87.692,7.86 l1.743,0.733V666.275z M336.341,659.142h0.426c2.848-0.64,23.979-5.266,50.033-7.638c35.299-3.212,63.438-1.088,83.741,6.312 V529.531c-27.9-11.728-28.985-11.63-83.15-6.712c-27.513,2.498-49.443,7.543-49.661,7.594l-0.318,0.074l-1.716,0l-0.318-0.074 c-0.218-0.051-22.148-5.095-49.661-7.594c-54.164-4.919-55.25-5.016-83.15,6.712v128.285c20.303-7.4,48.442-9.524,83.741-6.312 C312.362,653.876,333.493,658.502,336.341,659.142z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.307,
    y: 527.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.559,
    height: 134.348
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.051,
    y: 544.91,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.051,
    y: 565.307,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.051,
    y: 585.703,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.051,
    y: 606.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.901,
    y: 544.91,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.901,
    y: 565.307,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.901,
    y: 585.703,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.901,
    y: 606.1,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.048,
    height: 3.559
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "1562.184,468.979 1587.115,408.664 1601.12,472.408  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A6A9"
    },
    points: "1587.115,408.664 1611.999,454.833 1601.12,472.408  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "1671.574,523.475 1696.506,463.161 1710.511,526.905  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A6A9"
    },
    points: "1696.506,463.161 1721.39,509.329 1710.511,526.905  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "103.126,565.634 128.057,505.32 142.063,569.064  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A6A9"
    },
    points: "128.057,505.32 152.941,551.489 142.063,569.064  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7AD4B"
    },
    points: "1599.122,543.92 1635.371,456.226 1655.734,548.906  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A6A9"
    },
    points: "1635.371,456.226 1671.551,523.352 1655.734,548.906  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7AD4B"
    },
    points: "50,513.762 86.249,426.068 106.612,518.748  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5A6A9"
    },
    points: "86.249,426.068 122.429,493.194 106.612,518.748  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M899.251,865.284c-39.908,0-78.624-7.817-115.073-23.233c-35.204-14.89-66.819-36.205-93.968-63.354 c-27.149-27.149-48.464-58.764-63.354-93.968c-15.416-36.449-23.233-75.165-23.233-115.073s7.817-78.624,23.233-115.073 c14.89-35.204,36.205-66.819,63.354-93.968l5.032,5.033c-26.497,26.498-47.301,57.353-61.832,91.708 c-15.043,35.567-22.671,73.35-22.671,112.301s7.628,76.734,22.671,112.301c14.531,34.355,35.334,65.21,61.832,91.708 c26.497,26.498,57.352,47.301,91.708,61.832c35.567,15.044,73.35,22.671,112.301,22.671c38.95,0,76.734-7.628,112.301-22.671 c34.355-14.531,65.21-35.334,91.708-61.832c26.498-26.498,47.301-57.352,61.832-91.708 c15.043-35.567,22.671-73.35,22.671-112.301c0-38.95-7.628-76.734-22.671-112.301c-14.531-34.355-35.335-65.21-61.832-91.708 c-26.498-26.498-57.353-47.301-91.708-61.832c-35.567-15.044-73.35-22.671-112.301-22.671 c-38.685,0-76.236,7.531-111.611,22.384l-2.755-6.562c36.251-15.221,74.73-22.939,114.366-22.939 c39.908,0,78.624,7.817,115.073,23.234c35.204,14.89,66.819,36.205,93.968,63.354c27.149,27.149,48.464,58.764,63.354,93.968 c15.417,36.449,23.233,75.165,23.233,115.073c0,39.908-7.817,78.624-23.233,115.073c-14.89,35.204-36.205,66.819-63.354,93.968 c-27.149,27.149-58.765,48.464-93.968,63.354C977.875,857.467,939.159,865.284,899.251,865.284z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M899.205,882.46c-13.302,0-26.623-0.859-39.931-2.58c-40.098-5.185-78.362-17.936-113.73-37.898 c-35.368-19.963-66.059-46.132-91.22-77.78c-26.051-32.768-45.001-70.003-56.324-110.67 c-11.323-40.667-14.342-82.338-8.973-123.854c5.185-40.098,17.936-78.362,37.898-113.73 c19.963-35.368,46.132-66.059,77.78-91.22c32.768-26.051,70.003-45.001,110.67-56.324 c24.835-6.915,50.389-10.759,75.953-11.426l0.186,7.115c-24.981,0.652-49.955,4.409-74.229,11.167 c-39.745,11.066-76.131,29.584-108.149,55.039c-30.928,24.588-56.501,54.582-76.011,89.147 c-19.51,34.566-31.971,71.96-37.038,111.145c-5.246,40.566-2.294,81.287,8.771,121.032 c11.066,39.745,29.584,76.131,55.039,108.15c24.588,30.928,54.581,56.502,89.147,76.011 c34.566,19.51,71.96,31.971,111.145,37.038c12.999,1.681,26.02,2.52,39.014,2.52c27.556,0,55.009-3.772,82.018-11.292 c42.262-11.767,80.615-31.888,113.994-59.805c16.015-13.394,30.717-28.518,43.697-44.95 c12.875-16.298,24.134-33.982,33.465-52.559l6.36,3.195c-9.547,19.007-21.067,37.1-34.24,53.776 c-13.283,16.815-28.328,32.291-44.716,45.998c-34.161,28.571-73.408,49.162-116.651,61.202 C955.497,878.599,927.4,882.459,899.205,882.46z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M898.188,900.372c-6.601,0-13.213-0.195-19.838-0.587c-38.436-2.273-75.841-11.065-111.175-26.133 c-36.142-15.413-68.926-36.904-97.44-63.877l4.891-5.17c27.899,26.391,59.977,47.419,95.341,62.5 c34.579,14.746,71.186,23.351,108.803,25.575c37.871,2.24,75.427-2.073,111.628-12.817 c37.469-11.121,72.405-28.842,103.837-52.671c34.979-26.519,63.718-59.093,85.417-96.818 c20.96-36.44,34.506-76.129,40.262-117.966c5.756-41.836,3.432-83.709-6.908-124.455 c-10.705-42.183-29.579-81.308-56.097-116.288c-26.701-35.221-59.532-64.105-97.58-85.851 c-36.751-21.004-76.761-34.48-118.919-40.053l0.933-7.056c43.078,5.695,83.962,19.466,121.518,40.93 c38.885,22.224,72.436,51.741,99.72,87.73c27.097,35.743,46.383,75.725,57.324,118.837 c10.567,41.639,12.942,84.427,7.061,127.176c-5.882,42.749-19.724,83.306-41.143,120.544 c-22.177,38.555-51.544,71.844-87.287,98.941c-32.117,24.349-67.818,42.457-106.111,53.822 C961.761,895.786,930.145,900.372,898.188,900.372z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M1229.453,140.003c-32.347,0-58.856,24.994-61.27,56.722c2.411-31.685,28.852-56.652,61.14-56.72 h0.13v20.329c22.709,0,41.118,18.41,41.118,41.118c0,22.709-18.409,41.118-41.118,41.118v20.332 c-31.817,0-57.985-24.18-61.132-55.167c3.147,30.987,29.316,55.168,61.132,55.168c33.938,0,61.45-27.513,61.45-61.45 C1290.903,167.516,1263.392,140.003,1229.453,140.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471132"
    },
    d: "M1229.453,262.902v-20.332c-22.709,0-41.118-18.409-41.118-41.118 c0-22.708,18.409-41.118,41.118-41.118v-20.329h-0.13c-32.288,0.067-58.729,25.034-61.14,56.72 c-0.119,1.56-0.179,3.137-0.179,4.728c0,2.121,0.108,4.217,0.317,6.283C1171.468,238.722,1197.637,262.902,1229.453,262.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M1084.534,166.587C1084.534,166.587,1084.533,166.587,1084.534,166.587l0,8.287 c-9.257,0-16.76,7.504-16.76,16.76c0,9.255,7.504,16.76,16.76,16.76v8.287c0,0,0,0,0,0c13.833,0,25.047-11.214,25.047-25.047 C1109.581,177.801,1098.367,166.587,1084.534,166.587z M1084.534,204.331c-7.013,0-12.697-5.684-12.697-12.696 c0-7.012,5.684-12.696,12.697-12.696c7.012,0,12.696,5.684,12.696,12.696C1097.23,198.647,1091.546,204.331,1084.534,204.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471132"
    },
    d: "M1067.773,191.635c0-9.256,7.504-16.76,16.76-16.76v-8.287v-0.001 c-13.401,0-24.344,10.525-25.015,23.759c-0.022,0.427-0.033,0.857-0.033,1.289s0.011,0.862,0.033,1.289 c0.671,13.234,11.614,23.759,25.015,23.759v-0.001v-8.287C1075.277,208.395,1067.773,200.89,1067.773,191.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M1190.144,298.011c-11.684,0-21.157,9.472-21.157,21.157c0,11.685,9.473,21.158,21.157,21.158 c11.686,0,21.158-9.474,21.158-21.158C1211.302,307.483,1201.829,298.011,1190.144,298.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M1277.333,52.904c-15.172,0-27.473,12.3-27.473,27.473c0,15.173,12.3,27.475,27.473,27.475 c15.173,0,27.474-12.302,27.474-27.475C1304.807,65.204,1292.506,52.904,1277.333,52.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M1311.087,280.489c-6.296,0-11.4,5.104-11.4,11.401c0,6.296,5.104,11.399,11.4,11.399 c6.296,0,11.4-5.103,11.4-11.399C1322.488,285.593,1317.384,280.489,1311.087,280.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A9"
    },
    d: "M1158.751,252.224c-6.296,0-11.4,5.104-11.4,11.401c0,6.296,5.104,11.4,11.4,11.4 c6.296,0,11.4-5.104,11.4-11.4C1170.151,257.328,1165.047,252.224,1158.751,252.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M1374.849,173.457c-8.587,0-15.547,6.96-15.547,15.548c0,8.587,6.961,15.548,15.547,15.548 c8.588,0,15.549-6.961,15.549-15.548C1390.398,180.418,1383.437,173.457,1374.849,173.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.982 -0.1891 0.1891 0.982 -11.3598 146.5519)",
    style: {
      fill: "#862461"
    },
    cx: 762.29,
    cy: 132.804,
    rx: 56.199,
    ry: 56.199
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 753.363,
    y: 120.786,
    style: {
      fill: "#FFFFFF"
    },
    width: 17.852,
    height: 50.66
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M772.485,102.39c0,5.631-4.565,10.196-10.195,10.196c-5.631,0-10.195-4.565-10.195-10.196 c0-5.63,4.565-10.195,10.195-10.195C767.92,92.195,772.485,96.759,772.485,102.39z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.806,
    y: 756.507,
    style: {
      fill: "#A5A5A9"
    },
    width: 33.822,
    height: 22.335
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.806,
    y: 726.732,
    style: {
      fill: "#DBDBDA"
    },
    width: 33.822,
    height: 22.334
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.806,
    y: 787.39,
    style: {
      fill: "#4F4F50"
    },
    width: 33.822,
    height: 69.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.122,
    y: 756.507,
    style: {
      fill: "#A5A5A9"
    },
    width: 33.823,
    height: 22.335
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.122,
    y: 726.732,
    style: {
      fill: "#A5A5A9"
    },
    width: 33.823,
    height: 22.334
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.122,
    y: 697.178,
    style: {
      fill: "#DBDBDA"
    },
    width: 33.823,
    height: 22.334
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.122,
    y: 667.403,
    style: {
      fill: "#DBDBDA"
    },
    width: 33.823,
    height: 22.334
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.122,
    y: 787.39,
    style: {
      fill: "#4F4F50"
    },
    width: 33.823,
    height: 69.74
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.612,
    y: 786.836,
    style: {
      fill: "#A5A5A9"
    },
    width: 33.822,
    height: 22.334
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.612,
    y: 757.061,
    style: {
      fill: "#DBDBDA"
    },
    width: 33.822,
    height: 22.335
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.013,
    y: 834.795,
    style: {
      fill: "#4F4F50"
    },
    width: 33.823,
    height: 22.335
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.612,
    y: 817.718,
    style: {
      fill: "#4F4F50"
    },
    width: 33.822,
    height: 39.411
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M1109.582,679.617c-29.621,0-53.633,24.012-53.633,53.632c0,29.623,24.012,53.635,53.633,53.635 c29.62,0,53.634-24.012,53.634-53.635C1163.216,703.629,1139.203,679.617,1109.582,679.617z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1055.946,
    y: 679.614,
    width: 53.644,
    height: 107.276
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085210083492704758720000004936779042807995567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085210083492704758720000004936779042807995567_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471132"
    },
    d: "M1109.582,786.884c-29.621,0-53.633-24.012-53.633-53.635c0-29.62,24.012-53.632,53.633-53.632 V786.884z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M764.99,414.085c-14.608,0-26.45,11.842-26.45,26.449c0,14.609,11.842,26.451,26.45,26.451 c14.608,0,26.45-11.842,26.45-26.451C791.44,425.927,779.598,414.085,764.99,414.085z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000148627110611342321200000000969809092819208851_",
    x: 738.539,
    y: 414.084,
    width: 26.455,
    height: 52.904
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049189685643236491340000014332463021279114675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148627110611342321200000000969809092819208851_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049189685643236491340000014332463021279114675_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471132"
    },
    d: "M764.99,466.985c-14.608,0-26.45-11.842-26.45-26.451c0-14.607,11.842-26.449,26.45-26.449 V466.985z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M1618.947,308.761c-14.608,0-26.45,11.842-26.45,26.449c0,14.609,11.842,26.451,26.45,26.451 s26.45-11.842,26.45-26.451C1645.397,320.602,1633.555,308.761,1618.947,308.761z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111907463481000152600000001762254794835602593_",
    x: 1592.496,
    y: 308.759,
    width: 26.455,
    height: 52.904
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162350360160883652150000004318582094916395649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111907463481000152600000001762254794835602593_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000162350360160883652150000004318582094916395649_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E7229"
    },
    d: "M1618.947,361.66c-14.608,0-26.45-11.842-26.45-26.451c0-14.608,11.842-26.449,26.45-26.449 V361.66z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7AD4B"
    },
    d: "M1428.949,1020.617c-10.354,0-18.747,8.393-18.747,18.746c0,10.354,8.393,18.747,18.747,18.747 c10.353,0,18.746-8.393,18.746-18.747C1447.695,1029.01,1439.302,1020.617,1428.949,1020.617z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111170194913127595250000011236399511796591509_",
    x: 1410.201,
    y: 1020.617,
    width: 18.75,
    height: 37.496
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038392907147610269740000010463069261927629976_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111170194913127595250000011236399511796591509_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038392907147610269740000010463069261927629976_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E7229"
    },
    d: "M1428.949,1058.111c-10.354,0-18.747-8.393-18.747-18.747c0-10.353,8.393-18.746,18.747-18.746 V1058.111z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#862461"
    },
    d: "M268.075,86.135c-14.608,0-26.45,11.842-26.45,26.449c0,14.609,11.842,26.451,26.45,26.451 c14.608,0,26.45-11.842,26.45-26.451C294.526,97.976,282.683,86.135,268.075,86.135z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100342970069567047110000010468538720100467861_",
    x: 241.624,
    y: 86.133,
    width: 26.455,
    height: 52.904
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110467814115065723420000007064830779094862215_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100342970069567047110000010468538720100467861_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000110467814115065723420000007064830779094862215_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#471132"
    },
    d: "M268.075,139.034c-14.608,0-26.45-11.842-26.45-26.451c0-14.608,11.842-26.449,26.45-26.449 V139.034z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M1627.429,643.46c-12.941,0-23.432,10.49-23.432,23.431c0,12.942,10.491,23.432,23.432,23.432 c12.941,0,23.432-10.49,23.432-23.432C1650.861,653.951,1640.369,643.46,1627.429,643.46z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070085059667581812970000006839852941153121942_",
    x: 1603.995,
    y: 643.459,
    width: 23.437,
    height: 46.868
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128466519273289408950000000913383155284432014_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070085059667581812970000006839852941153121942_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128466519273289408950000000913383155284432014_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M1627.429,690.324c-12.941,0-23.432-10.49-23.432-23.432c0-12.941,10.491-23.431,23.432-23.431 V690.324z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M913.52,168.202c-12.941,0-23.432,10.49-23.432,23.431c0,12.942,10.491,23.432,23.432,23.432 c12.941,0,23.432-10.49,23.432-23.432C936.952,178.692,926.461,168.202,913.52,168.202z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000124844246693162976750000010921433502803253641_",
    x: 890.087,
    y: 168.201,
    width: 23.437,
    height: 46.868
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022539743583717382830000000038607216359398829_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124844246693162976750000010921433502803253641_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022539743583717382830000000038607216359398829_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M913.52,215.066c-12.941,0-23.432-10.49-23.432-23.432c0-12.941,10.491-23.431,23.432-23.431 V215.066z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M645.911,141.576c-8.327,0-15.077,6.75-15.077,15.076c0,8.327,6.75,15.077,15.077,15.077 c8.327,0,15.077-6.75,15.077-15.077C660.988,148.326,654.238,141.576,645.911,141.576z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179628139867527054930000014737070743338391442_",
    x: 630.833,
    y: 141.576,
    width: 15.08,
    height: 30.157
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083055160468397163210000003527490636210293936_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179628139867527054930000014737070743338391442_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083055160468397163210000003527490636210293936_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E4E4"
    },
    d: "M645.911,171.73c-8.327,0-15.077-6.75-15.077-15.077c0-8.326,6.75-15.076,15.077-15.076V171.73z "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDA"
    },
    d: "M578.421,991.403c0,11.095-8.994,20.09-20.09,20.09c-11.095,0-20.09-8.995-20.09-20.09 c0-11.095,8.995-20.09,20.09-20.09C569.426,971.313,578.421,980.308,578.421,991.403z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.62,455.101h42.192v211.799H536.62V455.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M593.06,455.101h59.236c58.398,0,105.899,47.501,105.899,105.899s-47.501,105.899-105.899,105.899 H593.06V455.101z M652.297,624.428c35.207,0,63.428-28.221,63.428-63.428c0-34.927-28.221-63.428-63.428-63.428h-17.044v126.856 H652.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M772.446,455.101H900.14v42.471h-85.502v42.192h85.502v42.471h-85.502v42.192h85.502v42.471 H772.446V455.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1067.51,666.899l-21.515-59.237H980.89l-21.515,59.237h-44.986l76.56-211.799h44.986 l76.56,211.799H1067.51z M1013.303,517.411l-17.044,47.78h34.369L1013.303,517.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1126.745,518.808c0-35.207,28.501-63.707,63.428-63.707c24.589,0,47.222,8.383,65.104,22.353 l-30.457,30.457c-9.78-6.427-21.794-10.338-34.648-10.338c-11.736,0-21.236,9.5-21.236,21.236c0,5.029,1.956,9.78,5.03,13.691 c6.706,7.544,17.603,8.941,28.221,9.5c34.648,1.677,61.193,25.707,61.193,61.472c0,34.927-28.501,63.428-63.428,63.428 c-28.501,0-54.207-11.177-73.207-29.339l29.898-29.898c11.456,10.618,26.545,17.044,43.31,17.044 c11.456,0,20.957-9.5,20.957-21.236c0-6.427-2.515-12.853-8.383-16.206c-10.059-5.868-26.824-4.191-37.442-6.706 C1147.422,573.574,1126.745,548.706,1126.745,518.808z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignInovationThinking);
export default __webpack_public_path__ + "static/media/design_inovation_thinking.e94f66f9710574371d8280faae9df209.svg";
export { ForwardRef as ReactComponent };